import { ReactElement, useEffect, useState } from "react";
import { TransitionPresence } from "@mediamonks/react-kit";
import { LenisWrapper } from "../utils/LenisWrapper/LenisWrapper.tsx";
import { EnableAnimationsProvider } from "../../providers/EnableAnimationsProvider.tsx";

export type ClientLayoutProps = {
  children: ReactElement;
};

export function ClientLayout({ children }: ClientLayoutProps): ReactElement {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    document.fonts.ready.then(() => {
      // TODO: Add Proper Font Loading
      setTimeout(() => {
        setFontsLoaded(true);
      }, 200);
    });
  }, []);

  return (
    <LenisWrapper root>
      <EnableAnimationsProvider value={fontsLoaded}>
        <TransitionPresence>{children}</TransitionPresence>
      </EnableAnimationsProvider>
    </LenisWrapper>
  );
}
